'use strict'
const $ = require('jquery');

const dom = {
  $accordionContainers: $('.accordion-element__container')
}

/**
 * Creates accordion elements. Accordion can be limited to small screens using class 'accordion-down-sm'.
 * Accordion is added to sub-elements with class 'accordion-element'. They should contain accordion-element__title' (with toggle icons 'up' & 'down') and 'accordion-element__content'.
 */
var accordion = {

  init: function() {
    //one page can have multiple accordion containers
    if (dom.$accordionContainers.length > 0) {
      dom.$accordionContainers.each(function () {
        //if hasClass accordion-down-sm, check viewport width and create accordion based on it.
        if($(this).hasClass('accordion-down-sm')) {
          const breakpoint = 770;
          const $accordionContainer = $(this);

          //get viewportSize
          let vw = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);

          if(vw < breakpoint) {
            accordion.createAccordion($accordionContainer);
            $accordionContainer.addClass('accordion--active');
          }
          //if window is resized, check if accordion needs to be removed
          $( window ).resize(function() {
            accordion.handleResize($accordionContainer, breakpoint);
          });

        } else {
          //accordion for all screen sizes
          accordion.createAccordion($(this));
          $(this).addClass('accordion--active');
        }
      });
    }
  },

  /**
   * Find all accordion elements inside the container, give the functionality
   * @param {jqueryobject} $container , container for accordion elements
   */
  createAccordion: function($container) {
    const elements = $container.find('.accordion-element');

    elements.each(function () {

      const $element = $(this);

      //find elements
      const $title = $element.find('.accordion-element__title');
      const $accordionContent= $element.find('.accordion-element__content');
      let $upArrow = $title.find('.up').hide();
      let $downArrow = $title.find('.down').show();

      //if all elements are found
      if($title && $accordionContent && $upArrow && $downArrow) {

        //wrap title to a button
        $title.wrap( '<button class="toggle-accordion" type="button"></button>' );
        const $accordionToggle =  $element.find('.toggle-accordion').attr('aria-expanded','false');

        //hide content
        $accordionContent.hide();

        //toggle content visibility on click
        $accordionToggle.on('click', function () {
          if (!$accordionContent.hasClass('open')) {
            $container.find('.open').removeClass('open').slideUp(); //close others
            $accordionContent.addClass('open').slideDown();
            $(this).attr('aria-expanded','true');
            $downArrow.hide();
            $upArrow.show();
          } else {
            $accordionContent.removeClass('open').slideUp();
            $(this).attr('aria-expanded','false');
            $upArrow.hide();
            $downArrow.show();
          }
        });
      } else {
        console.log('Elements missing, can not create accordion');
      }

    });
  },

  /**
   * Remove or hide accordion elements inside the container
   * @param {jqueryobject} container , container for accordion elements
   */
  removeAccordion: function(container) {
    const elements = container.find('.accordion-element');

    elements.each(function () {

      const $element = $(this);

      //remove toggle button
      $element.find('.toggle-accordion > .accordion-element__title').unwrap();

      //show content and remove classes
      const $accordionContent= $element.find('.accordion-element__content');
      if ($accordionContent.hasClass('open')) {
        $accordionContent.removeClass('open');
      } else {
        $accordionContent.show();
      }

      //hide toggle icons
      $element.find('.up').hide();
      $element.find('.down').hide();
    });
  },

  /**
   * After window resize, check if accordion needs to be removed or added
   * @param {jqueryobject} $accordionContainer , container for accordion elements
   * @param {number} breakpoint, breakpoint for viewport size
   */
  handleResize: function($accordionContainer, breakpoint) {
    //get viewport width
    const vw = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);

    if(vw < breakpoint && !$accordionContainer.hasClass('accordion--active')) {
      //create accordion element
      accordion.createAccordion($accordionContainer);
      $accordionContainer.addClass('accordion--active');
    } else if (vw >= breakpoint && $accordionContainer.hasClass('accordion--active')) {
      //remove accordion element
      accordion.removeAccordion($accordionContainer);
      $accordionContainer.removeClass('accordion--active');
    }
  }


}

module.exports = accordion;

